import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const OutsideTempGlyph = /*#__PURE__*/createElement("g", {
  id: "outside_temperature"
}, /*#__PURE__*/createElement("path", {
  d: "M71.3,42.7V27.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.3-0.1-0.5,0 c-0.2,0-0.5,0.2-0.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.2-0.1,0.3-0.1,0.5v15.2H71.3z M70.1,60.9c-5.7,0-7.9-7.4-3.1-10.5V27.5 c0-0.4,0.1-0.9,0.3-1.3c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.2,0.4-0.3,0.6-0.4c0.3-0.2,0.7-0.3,1.1-0.4c0.5-0.1,0.9,0,1.4,0.1 c0.4,0.1,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.9,0.3,1.3v22.9C78,53.5,75.8,60.9,70.1,60.9"
}), /*#__PURE__*/createElement("path", {
  d: "M32.6,14.3c0.1-0.1,0.1-0.1,0.2,0C40.9,23.2,49,32.1,57.1,41c0.6,0.6,1.5,0.6,2.1,0.1c0.6-0.6,0.6-1.5,0.1-2.1 C51,29.9,42.8,20.8,34.5,11.8c-1-1.1-2.6-1.1-3.6,0C22.6,20.8,14.3,29.9,6,39c-0.6,0.6-0.5,1.5,0.1,2.1c0.6,0.6,1.5,0.5,2.1-0.1 C16.3,32.1,24.5,23.2,32.6,14.3"
}), /*#__PURE__*/createElement("path", {
  d: "M51.6,65.9c0,0.1,0,0.1-0.1,0.1H13.9c-0.1,0-0.1,0-0.1-0.1V52.2v-6.9c0-0.9,0.2-1.7,0-2.7c-0.1-0.5-0.4-0.8-0.9-1 c-0.9-0.3-1.9,0.3-2,1.3c-0.1,2.3,0,4.6,0,6.8v6.9v6.9v3c0,1.4,1.1,2.5,2.4,2.5h38.9c1.4,0,2.4-1.1,2.4-2.5v-3v-6.9v-6.9 c0-2.3,0.1-4.6,0-6.9c-0.1-1-1-1.7-2-1.3c-0.5,0.2-0.8,0.5-0.9,1c-0.2,0.9,0,1.8,0,2.6v6.9V65.9"
}));
const OutsideTemp = createSvg({
  name: 'outside_temp',
  path: OutsideTempGlyph
});

export default OutsideTemp;
export { OutsideTempGlyph };
